import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import logo1 from "../Components/images/logo1.jpeg";

const Navbar = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return (
    <nav className="navbar navbar-expand-lg navbar-dark navbar-custom fixed-top custom-navbar from-top">
      <div className="container-fluid">
        <Link className="navbar-brand d-flex align-items-center" to="/">
          <img src={logo1} alt="Logo" className="logo-icon" />
          <span className='ftfl0'>Dropshopi</span>
        </Link>
        <button
          className="navbar-toggler border-0"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarContent"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse justify-content-between" id="navbarContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0 align-items-center">
            <li className="nav-item">
  {isMobile ? (
    <a href="/about" className="nav-link inter text-white">About</a>
  ) : (
    <Link to="/about" className="nav-link inter text-white">About</Link>
  )}
</li>
<li className="nav-item">
  {isMobile ? (
    <a href="/blog" className="nav-link inter text-white">Blog</a>
  ) : (
    <Link to="/blog" className="nav-link inter text-white">Blog</Link>
  )}
</li>
<li className="nav-item">
  {isMobile ? (
    <a href="/services" className="nav-link inter text-white">Services</a>
  ) : (
    <Link to="/services" className="nav-link inter text-white">Services</Link>
  )}
</li>

            <li className="nav-item">
              {isMobile ? (
                <a href="/#proccess" className="nav-link inter text-white">Process</a>
              ) : (
                <Link to="/#proccess" className="nav-link inter text-white">Process</Link>
              )}
            </li>
          </ul>
          <Link to="contact" className="btn btn-purple d-flex align-items-center">
            Claim Free Session! <span className="ms-2"></span>
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
